// TODO: a way to bypass using epics. temporary solution

import { tokenManager } from 'core/redux/api/authorization';

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export const asyncRequest = async <T>(url: string, method: Method = 'GET', body?: unknown): Promise<T> => {
  const token = tokenManager.getAccessToken()?.jwt;

  const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/v3/${url}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body && { 'Content-Type': 'application/json' }),
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  return response.json();
};
